var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.7925L24.6136 23.3775C25.0398 22.6875 25.2955 21.825 25.2955 20.9625C25.2955 18.5475 23.4205 16.65 21.0341 16.65C18.6477 16.65 16.7727 18.5475 16.7727 20.9625C16.7727 23.3775 18.6477 25.275 21.0341 25.275C21.8864 25.275 22.7386 25.0163 23.4205 24.585L25.8068 27L27 25.7925ZM18.4773 20.9625C18.4773 19.4963 19.5852 18.375 21.0341 18.375C22.483 18.375 23.5909 19.4963 23.5909 20.9625C23.5909 22.4288 22.483 23.55 21.0341 23.55C19.5852 23.55 18.4773 22.4288 18.4773 20.9625ZM8.25 14.925H16.7727V16.65H8.25V14.925ZM8.25 9.75H18.4773V11.475H8.25V9.75Z",
    fill: "#004B2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 25.0286L8.7375 22.6286C6.20625 21.3429 4.6875 18.6857 4.6875 15.8571V4.71429H21.5625V14.1429H23.25V4.71429C23.25 3.77143 22.4906 3 21.5625 3H4.6875C3.75937 3 3 3.77143 3 4.71429V15.8571C3 19.3714 4.85625 22.5429 7.89375 24.1714L13.125 27V25.0286Z",
    fill: "#004B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelData);
export default __webpack_public_path__ + "static/media/panel-data.d55c8f77614b7978fa65323a74061146.svg";
export { ForwardRef as ReactComponent };